const InternationalFreight = () => {
    return (
    <div>
      <div className="">
        <img src="/logisticsBanner/banner-5.jpg" width="100%"/>
      </div>
      <div className="flex flex-col justify-center items-center mb-[1.5rem]">
        <hr className="w-[52rem] mx-auto"/>
        <div className="lg:flex md:grid flex-1 justify-center items-start mx-auto max-w-[60rem] my-[5rem] gap-5">
         
          <div className="flex flex-col justify-center">
            <h1 className="font-bold text-3xl text-[#373737]">
            International Freight
            </h1>
            <p
              className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]"
            >
              TCS provides seamless regional and global connectivity through its vast network
              which includes the leading logistics players from the west to the east. With international 
              gateways in Karachi and Lahore, our regional hub in the UAE and growing partnerships in Central
              Asia and the world, we are focused on enabling and enhancing trade and commerce for ‘Made in Pakistan’ 
              as the Logistics Backbone of our economy.
            </p>
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              As the only logistics player in Pakistan with the Transports Internationaux Routiers (TIR) licence 
              and a Boeing air freighter, we are at the forefront of driving multi-modal regional connectivity, 
              and empowering CPEC as well as Pakistan’s role in the OBOR initiative.
            </p>
        
            <p className="text-sm text-md  lg:max-w-[25rem] md:w-[30rem] mt-[1rem]">
              With certified standards and trained resources, we are ISO 9001: ——, ISO 9002: ——,DGR, IATA, PIFFA,
              FIATA and ACAAP compliant. From getting a shipment ready, and handling customs, to tracking, monitoring
              and buyer consolidation, we know exactly how to manage your international freight requirements.
            </p>
          </div>
          <div className="flex-1 flex flex-col justify-center">
            <img src="/Home/trainingdevelop/traning-1.jpg" alt="" className="max-w-[45rem] h-[30vh]"/>
          </div>
        </div>
      
      </div>
      
    </div>

  )
};
export default InternationalFreight;